var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import Plugin from '../../plugin';

var MiniProgress = function (_Plugin) {
  _inherits(MiniProgress, _Plugin);

  function MiniProgress() {
    _classCallCheck(this, MiniProgress);

    return _possibleConstructorReturn(this, (MiniProgress.__proto__ || Object.getPrototypeOf(MiniProgress)).apply(this, arguments));
  }

  _createClass(MiniProgress, [{
    key: 'afterCreate',
    value: function afterCreate() {}
  }, {
    key: 'update',
    value: function update() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { cached: 0, played: 0 };
      var duration = arguments[1];

      if (!duration || !this.root) {
        return;
      }
      if (data.cached) {
        this.find('xg-mini-progress-cache').style.width = data.cached / duration * 100 + '%';
      }
      if (data.played) {
        this.find('xg-mini-progress-played').style.width = data.played / duration * 100 + '%';
      }
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.playerConfig.progress || !this.playerConfig.miniprogress) {
        return;
      }
      return '<xg-mini-progress class="xg-mini-progress">\n    <xg-mini-progress-cache class="xg-mini-progress-cache"></xg-mini-progress-cache>\n    <xg-mini-progress-played class="xg-mini-progress-played"></xg-mini-progress-played>\n    </xg-mini-progress>';
    }
  }], [{
    key: 'pluginName',
    get: function get() {
      return 'MiniProgress';
    }
  }, {
    key: 'defaultConfig',
    get: function get() {
      return {};
    }
  }]);

  return MiniProgress;
}(Plugin);

export default MiniProgress;